import { useDynamicConfig } from 'hooks/use-dynamic-config.hook';
import { useConfigWithFeatureFlags } from 'hooks/use-config-with-feature-flags';
import { useConditionalNavigation } from 'hooks/use-conditional-navigation.hook';
import { useInterceptLinkClick } from 'hooks/use-intercept-link-click.hook';
import { useProductSegmentation } from 'hooks/use-product-segmentation.hook';
import { PARTNER_TOKEN_CONFIG } from 'common/partner-config';

interface UseAppRoutesConfig {
  onSsoRestriction?: () => void;
}

interface UseAppRoutesReturn {
  isFormCenterAvailable: boolean;
  initializeApp: () => void;
}

export const useAppRoutes = ({
  onSsoRestriction,
}: UseAppRoutesConfig = {}): UseAppRoutesReturn => {
  useDynamicConfig();
  useConfigWithFeatureFlags();
  useConditionalNavigation();
  useInterceptLinkClick({
    patternsToIntercept: [
      ...PARTNER_TOKEN_CONFIG.REGULAR_PATTERNS,
      ...PARTNER_TOKEN_CONFIG.SECURED_PATTERNS,
    ],
    rootUrl: import.meta.env.VITE_LINKOUT_ROOT_URL,
    onRestrictedAction: onSsoRestriction,
  });

  const { showFormsCenter } = useProductSegmentation();
  const isFormCenterAvailable = showFormsCenter;

  const initializeApp = () => {};

  return {
    isFormCenterAvailable,
    initializeApp,
  };
};
